// Container.js
// -----------------------------------------------------------------------------
// Presentational max-width content wrapper that centers and horizontally pads
// its children. Used internally by <Section> but also reusable directly.
//
// Props:
//   - maxWidth  : 'sm'|'md'|'lg'|'xl'   (default 'lg') content max width
//   - disableGutters : boolean          (default false) remove horizontal pad
//   - sx        : object                (default {})    extra Joy sx overrides
//   - children  : node                  (required)      content to wrap
// -----------------------------------------------------------------------------

import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/joy/Box';

const MAX_WIDTHS = {
  sm: '640px',
  md: '880px',
  lg: '1180px',
  xl: '1440px',
};

const Container = ({ maxWidth = 'lg', disableGutters = false, sx = {}, children }) => {
  // Zero-trust: constrain maxWidth to the known set, default to 'lg'.
  const resolvedMax = MAX_WIDTHS[maxWidth] || MAX_WIDTHS.lg;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: resolvedMax,
        mx: 'auto',
        px: disableGutters ? 0 : { xs: 2.5, sm: 4, md: 5 },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

Container.propTypes = {
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  disableGutters: PropTypes.bool,
  sx: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default Container;
